import React from 'react';
import styled from 'styled-components';
import { buildImageSource, buildImageSourceSet } from '../../utils/buildImageSource';
import { Image } from '../media/Image';
import type { ContentUI } from './types';

const VideoTag = styled.video.attrs({
    playsInline: true,
    muted: true,
    preload: 'auto',
    autoPlay: false,
})`
    object-fit: cover;
    object-position: center;
`;

interface MediaPreviewProps {
    namespace?: string;
    media: ContentUI;
}

export const MediaPreview = (props: MediaPreviewProps) => {
    const { media, namespace } = props;

    if (media.type === 'image') {
        return (
            <Image
                src={buildImageSource(media.media, namespace)}
                srcSet={buildImageSourceSet(media.media, namespace)}
            />
        );
    }

    const [firstMedia] = media.media;

    if (media.type === 'video') {
        if (firstMedia.previewFormats) {
            return (
                <Image
                    src={buildImageSource(firstMedia.previewFormats, namespace)}
                    srcSet={buildImageSourceSet(firstMedia.previewFormats, namespace)}
                />
            );
        }
        if (firstMedia.firstFrameUrl) {
            return <Image src={firstMedia.firstFrameUrl} />;
        }

        return (
            <VideoTag>
                <source src={firstMedia.url} />
            </VideoTag>
        );
    }

    return null;
};
